import { useCallback } from 'react';

import { expectSupporterToLeave } from '#src/app/pages/psf/share/shared/utils';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useShareGoalCounter } from '../useShareGoalCounter';

/**
 * Channels that don't leave the page as the share starts: copying, or a share sheet or modal opened over it,
 * where the hand-off waits on a later tap in it.
 */
const STAYS_ON_PAGE: ReadonlySet<ShareChannel> = new Set([
	'copy',
	'instagram',
	'instagramStories',
	'mobileNativeShare',
	'tiktok',
]);

/**
 * With the Share Goal Counter, a share that hands off to another app tells it up front that the supporter is
 * leaving, so the new step doesn't pop in during the switch.
 */
export function useOnShareStart(): NonNullable<ShareActionsOptions['onBeforeShare']> {
	const { isActive } = useShareGoalCounter();

	return useCallback(
		(channel) => {
			if (isActive && !STAYS_ON_PAGE.has(channel)) expectSupporterToLeave();
		},
		[isActive],
	);
}
